import NoData from "components/noData/noData";
import { useAddonsWishList } from "hooks/useWishList";
import WishlistTabs from "./component/wishlistTabs";
import { json } from "helpers/data";
import WishListCard from "./component/wishListCard";
import { useQueryClient } from "react-query";
import { useMount } from "react-use";
import { Spinner } from "react-bootstrap";
import ErrorMessage from "components/error/error";
import { useAuthContext } from "store/auth";
import InvoicesPdf from "pages/invoices/component/invoices.pdf";

const WishListAddons = () => {
	const [{user}]  = useAuthContext();
	const customerId = user.Id;;

	const { addonsWishList, isLoading, isFetching, isSuccess,isError } =
		useAddonsWishList(customerId);
	const queryClient = useQueryClient();
	useMount(() => {
		queryClient.invalidateQueries(["addons-wishList"]);
	});

	return (
		<div className="wishlist wishlist-addons">
			<WishlistTabs />
			<div className="row">
			{isError && <ErrorMessage />}
				{(isLoading || isFetching) && (
					<div className="my-center">
						<Spinner animation="grow" variant="primary" />
					</div>
				)}
				{isSuccess && addonsWishList.length > 0 ? (
					addonsWishList.map(({ addOn, id, addOnId }) => (
						<div
							className="col-xl-2 col-lg-3 col-md-4 col-sm-6"
							key={id}
						>
							<WishListCard
								id={id}
								itemId={addOnId}
								title={json(addOn.name)}
								Label={addOn.label}
								logo={addOn.logo.fullPath}
								info={json(addOn.title)}
								content={json(addOn.shortDescription)}
								price={addOn.price}
							/>
						</div>
					))
				) :  ( isSuccess || addonsWishList.length < 0) && <NoData packages={"wishlist"} />}
			</div>

		</div>
	);
};

export default WishListAddons;
